import {
  Box,
  Button,
  Dialog,
  Divider,
  Fade,
  ListItemIcon,
  Menu,
  MenuItem,
  Paper,
  Typography,
  useTheme,
} from '@material-ui/core';
import { LanguageConfiguration } from 'components/app_common/LanguageSelector/configuration';
import { useHistory } from 'react-router';
import * as LanguageSelectors from 'redux/reducers/gl_translations_reducer/selectors';
import { LanguagesEnum } from 'constants/languages';
import { useDispatch } from 'react-redux';

interface TermsPopupProps {
  open: boolean;
  onClose: () => void;
}
export function GamePopup({ open, onClose }: TermsPopupProps) {
  const history = useHistory();
  const dispatch = useDispatch();

  const languageID: LanguagesEnum = LanguageSelectors.useSelectLanguageID();

  const action = () => history.push('/game');

  return (
    <Dialog open={open} onClose={onClose}>
      <Paper style={{ padding: '1em' }}>
        <Typography style={{ fontSize: '24px', fontWeight: 'bold' }}>
          Before resuming...
        </Typography>
        <Divider />

        <Fade in={true} timeout={400}>
          <Box style={{ padding: '1em 0' }}>
            <Typography>
              1. Preferrably use a 'Gaming PC' and ensure you have good network
              speed for a better experience.
            </Typography>
            <Typography>
              2. Please use any browser that supports WebGL (
              <span
                style={{ fontWeight: 'bold', textDecoration: 'line-through' }}
              >
                Safari
              </span>
              ).
            </Typography>
            <Typography>3. Loading requires up to 2-3 minutes.</Typography>
            <Typography>
              4. In case the game/player freezes or crashes, refresh the page.
            </Typography>
          </Box>
        </Fade>

        <Fade in={true} timeout={400}>
          <Box style={{ padding: '1em 0' }}>
            <Typography style={{ fontSize: '24px', fontWeight: 'bold' }}>
              Choose your language
            </Typography>
            <Divider />

            {LanguageConfiguration.map((props, index: number) => (
              <MenuItem
                style={{
                  // marginLeft: props.submenu ? 5 : 0,
                  fontWeight: 600,
                  fontSize: 16,
                  color: languageID === props.id ? 'blue' : 'grey',
                }}
                key={index}
                onClick={() => {
                  dispatch(props.action);
                }}
              >
                {props.icon && <ListItemIcon>{props.icon}</ListItemIcon>}
                <Typography variant="inherit">{props.label}</Typography>
              </MenuItem>
            ))}
          </Box>
        </Fade>
        <Divider />

        <Fade in={true} timeout={600}>
          <Box
            style={{
              display: 'flex',
              alignContent: 'center',
              justifyContent: 'end',
              gap: '0.5em',
              padding: '0.5em 0 0 0 ',
            }}
          >
            <Button
              variant={'contained'}
              onClick={() => {
                onClose();
              }}
              style={{
                background: '#f44336',
                color: 'white',
              }}
            >
              Cancel
            </Button>

            <Button
              variant={'contained'}
              onClick={() => {
                action();
                onClose();
              }}
              style={{
                background: '#04AA6D',
                color: 'white',
              }}
            >
              OK
            </Button>
          </Box>
        </Fade>
      </Paper>
    </Dialog>
  );
}
